import { Component, forwardRef, Input } from '@angular/core';
import {
  ControlValueAccessor,
  FormControl,
  NG_VALIDATORS,
  NG_VALUE_ACCESSOR
} from '@angular/forms';

@Component({
  selector: 'ls-input-grid',
  templateUrl: './input-grid.component.html',
  styleUrls: ['./input-grid.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => InputGridComponent),
      multi: true
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => InputGridComponent),
      multi: true
    }
  ]
})
export class InputGridComponent implements ControlValueAccessor {
  @Input()
  public gridValues: Array<string> = [
    'A',
    'B',
    'C',
    'D',
    'E',
    'F',
    'G',
    'H',
    'I',
    'J',
    'K',
    'L'
  ];
  public maxLength = 10;

  public writeValue(value: Array<string>): void {
    if (value) {
      this.gridValues = value;
    }
  }

  public registerOnChange(fn: Function): void {
    this.propagateChange = fn;
  }

  public registerOnTouched(): void {
    return;
  }

  public propagateChange: any = () => {
    return;
  };

  public validate: any = (control: FormControl) => {
    if (!control.dirty) {
      return null;
    }
  };

  public trackByMethod(index: number): number {
    return index;
  }

  public textValueChanged($event: any, index: number): void {
    this.gridValues[index] = $event.target.value;
    this.propagateChange(this.gridValues);
  }
}
